

export default function IntroBlock({ children }) {

    return (
        <h1 className="text-justify xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] m-5 md:py-12 py-5 md:text-5xl text-3xl font-bold" >
            {children}
        </h1>
    )
}